import { WidgetName } from '../../enums/conversation';
import BookingConfirmation from './BookingConfirmation';
import BookingSelection from './BookingSelection';
import HTMLContent from './HTMLContent';
import IframeContent from './Iframe';
import PassengerModification from './PassengerModification';
import RefundEstimate from './RefundEstimate';
import RefundTimeline from './RefundTimeline';
import ResolutionConfirmation from './ResolutionConfirmation';
import TdrReasonSelection from './TdrReasonSelection';
import { Message, MessageWidget } from './index.types';

type Props = {
    isLastMessage: boolean;
    message: Message;
    widgetData: MessageWidget;
};

function Widget({ isLastMessage, message, widgetData }: Props) {
    switch (widgetData.name) {
        case WidgetName.BOOKING_CONFIRMATION:
            return <BookingConfirmation message={message} widgetData={widgetData} />;

        case WidgetName.BOOKING_SELECTION:
            return <BookingSelection isLastMessage={isLastMessage} message={message} widgetData={widgetData} />;

        case WidgetName.FARE_SUMMARY:
            return <RefundEstimate message={message} widgetData={widgetData} />;

        case WidgetName.HTML:
            return <HTMLContent message={message} widgetData={widgetData} />;

        case WidgetName.PAX_MODIFICATION:
            return <PassengerModification isLastMessage={isLastMessage} message={message} widgetData={widgetData} />;

        case WidgetName.QUERY_RESOLUTION:
            return <ResolutionConfirmation isLastMessage={isLastMessage} message={message} widgetData={widgetData} />;

        case WidgetName.REFUND_TIMELINE:
            return <RefundTimeline message={message} widgetData={widgetData} />;

        case WidgetName.TDR_REASON_SELECTION:
            return <TdrReasonSelection isLastMessage={isLastMessage} message={message} widgetData={widgetData} />;

        case WidgetName.IFRAME:
            return <IframeContent message={message} widgetData={widgetData} />;

        default:
            return null;
    }
}

export default Widget;
